import { useState } from "react";
import { routeHref } from "../routes";
import "./Header.scss";

const menu = [
  { label: "DESPRE NOI", href: routeHref("/despre-noi") },
  { label: "ȘT. VINDECĂRII GERMANICE", href: routeHref("/stiinta-vindecarii-germanice") },
  { label: "PERSONOCRAȚIA", href: routeHref("/personocratia") },
  { label: "ATELIERE", href: routeHref("/ateliere") },
  { label: "ARTICOLE", href: routeHref("/articole") },
  { label: "TESTIMONIALE", href: routeHref("/testimoniale") },
  { label: "CONTACT", href: routeHref("/contact") },
];

function Brand({ onClick, className = "" }: { onClick: () => void; className?: string }) {
  return (
    <a className={["brand", className].filter(Boolean).join(" ")} href={routeHref("/")} aria-label="Personocrația — Acasă" onClick={onClick}>
      <span className="brand__name">Personocrația</span>
      <span className="brand__subtitle">ASOCIAȚIA UMANITARĂ PENTRU PROMOVAREA SĂNĂTĂȚII</span>
    </a>
  );
}

export function Header({ route }: { route: string }) {
  const [open, setOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="site-header__brand-row">
        <div className="site-header__inner">
          <Brand onClick={() => setOpen(false)} />
          <button
            className="menu-toggle"
            type="button"
            aria-expanded={open}
            aria-controls="mobile-menu"
            onClick={() => setOpen(!open)}
          >
            {open ? "Închide" : "Meniu"}
            <span className="menu-toggle__icon" aria-hidden="true">{open ? "×" : "☰"}</span>
          </button>
        </div>
      </div>
      <nav className="desktop-nav" aria-label="Navigație principală">
        <div className="desktop-nav__inner">
          <Brand className="brand--desktop" onClick={() => setOpen(false)} />
          {menu.map(item => (
            <a
              key={item.label}
              href={item.href}
              className={(route === item.href || route.startsWith(item.href) || (route === "/" && item.label === "DESPRE NOI")) ? "is-active" : ""}
              aria-current={route === item.href ? "page" : undefined}
            >
              {item.label}
            </a>
          ))}
        </div>
      </nav>
      {open && (
        <nav className="mobile-nav" id="mobile-menu" aria-label="Navigație mobilă">
          {menu.map(item => (
            <a key={item.label} href={item.href} onClick={() => setOpen(false)}>
              {item.label}<span aria-hidden="true">↗</span>
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}
